export default __webpack_public_path__ + "static/media/Ficho-verde.c501bc62.png";